import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { logoutUser } from 'store/auth/authAsync';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import { Button } from 'components/Buttons';

const PublicDevicePlayable:FC = () => {
  const { t } = useTranslation('common');
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);

  const handleClick = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      window.location.reload();
    } catch(error){}
  }

  if ( quiz.type === QuizTypes.Personality ) return null;
  if ( !quiz.publicDevicePlayableOnly ) return null;
  return (
    <div className="bg-white p-2">
      <div
        className="
          flex items-center justify-between
          bg-primary
          rounded
          py-2 px-4
        "
      >
        <span className="text-white text-sm font-bold">{t('components.publicDevicePlayable.restartQuizForNextPlayer')}</span>
        <Button
          className="rounded-md px-6 text-black"
          onClick={handleClick}
          size="small"
        >{t('components.publicDevicePlayable.ok')}</Button>
      </div>
    </div>
  )
}

export default PublicDevicePlayable;
